/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';

const DSFullPageContainerScroll = ({ style = {}, children, ...props }) => (
  <Grid maxHeight="100%" style={{ overflow: 'auto', ...style }} {...props}>
    {children}
  </Grid>
);

export { DSFullPageContainerScroll };
